<template>
    <div>
        <el-row>
            <el-col class="box">
                <div class="list__header">
                    <p class="list__title">
                        Zdjęcia w galerii
                    </p>
                </div>
                <el-upload
                        class="upload"
                        drag
                        :http-request="uploadImage"
                        action=""
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Przeciągnij plik tutaj lub <em>kliknij aby dodać</em></div>
                </el-upload>
                <el-table :data="images"
                          highlight-current-row
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="70"></el-table-column>
                    <el-table-column label="zdjęcie">
                        <template slot-scope="scope">
                            <img class="thumbnail" :src="scope.row.thumbnail" :alt="scope.row.alt_pl">
                        </template>
                    </el-table-column>
                    <el-table-column label="autor">
                        <template slot-scope="scope">
                            <el-input v-if="imageDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].author"
                                      type="text"/>
                            <span v-show="!imageDuringEdition(scope.row)">{{ scope.row.author }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="alt (pl)">
                        <template slot-scope="scope">
                            <el-input v-if="imageDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].alt_pl"
                                      type="text"/>
                            <span v-show="!imageDuringEdition(scope.row)">{{ scope.row.alt_pl }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="alt (en)">
                        <template slot-scope="scope">
                            <el-input v-if="imageDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].alt_en"
                                      type="text"/>
                            <span v-show="!imageDuringEdition(scope.row)">{{ scope.row.alt_en }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="opcje" width="250" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <el-button title="Edytuj szczegóły zdjęcia"
                                       v-show="!imageDuringEdition(scope.row)"
                                       size="small"
                                       @click="editImage(scope.row)"><i
                                    class="el-icon-edit"></i>
                            </el-button>
                            <el-button title="Zatwierdź edycję"
                                       v-show="imageDuringEdition(scope.row)"
                                       size="small"
                                       type="primary"
                                       @click="submitEditedImage(scope.row)"><i
                                    class="el-icon-check"></i>
                            </el-button>
                            <el-button @click.stop="changeOrder(images, scope.$index, 1)"
                                       v-if="scope.$index !== images.length - 1"
                                       size="small"
                                       title="Przesuń w dół">
                                <i class="fa fa-arrow-down"></i>
                            </el-button>
                            <el-button @click.stop="changeOrder(images, scope.$index, -1)"
                                       :style="{opacity: scope.$index !== 0 ? 1 : 0}"
                                       size="small"
                                       title="Przesuń do góry">
                                <i class="fa fa-arrow-up"></i>
                            </el-button>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="removeItemFromFormset(images, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {Image} from '@/api';

    export default {
        props: ['images'],
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                data: [],
                service: Image,
                duringEditing: {}
            }
        },
        methods: {
            imageDuringEdition (image) {
                return this.duringEditing[image.id] !== undefined
            },
            editImage (image) {
                this.$set(this.duringEditing, image.id, image)
            },
            submitEditedImage (image) {
                Image.update(image.id, this.duringEditing[image.id]).then(response => {
                    this.$message({
                        message: 'Element został zaaktualizowany',
                        type: 'success'
                    })
                    this.duringEditing[image.id] = undefined
                })
            },
            handleDelete (index, row) {
                console.log('usun zdjecie')
            },
            uploadImage (event) {
                this.sendFile(event.file)
            },
            sendFile (file) {
                const data = new FormData()
                data.append("raw_image", file, file.name)
                return Image.save(data).then(response => {
                    this.uploadSuccess(response)
                }).catch(error => {
                    this.uploadError(error)
                })
            },
            uploadSuccess (response) {
                this.images.unshift(response.data)
            },
            uploadError (error) {
                console.error(error, 'error while file uploading')
                this.$message({
                    message: "Wystąpił problem podczas wysyłania pliku.",
                    type: 'error'
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .upload {
        margin-bottom: 40px;
    }

    .thumbnail {
        max-width: 140px;
    }
</style>



// WEBPACK FOOTER //
// GalleryImages.vue?59273c52